import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import IslandRail from '../island/IslandRail';

export default function Home() {
  const { categories, towns } = useSelector((state) => state.config);

  // Every figure on this page is counted from what the API actually returned.
  // A directory whose selling point is that its numbers are checked cannot
  // print a rounded one on its own front page.
  const { listings, communities } = useMemo(
    () =>
      towns.reduce(
        (acc, town) => ({
          listings:
            acc.listings +
            (town.businesses_count || 0) +
            (town.communities || []).reduce((sum, c) => sum + (c.businesses_count || 0), 0),
          communities: acc.communities + (town.communities?.length || 0),
        }),
        { listings: 0, communities: 0 }
      ),
    [towns]
  );

  return (
    <>
      <section className="hero">
        <div className="wrap">
          <span className="eyebrow">Long Beach Island, New Jersey</span>
          <h1>What is open on the Island.</h1>
          <p className="lede">
            Barnegat Light down to Holgate. Who is open, who is seasonal, and who keeps the lights
            on after Columbus Day — with the date we last confirmed it on every listing.
          </p>
          <div className="hero-actions">
            <Link className="btn btn-primary" to="/directory">
              Browse the directory
            </Link>
            <Link className="btn" to="/submit">
              Add your business
            </Link>
          </div>
        </div>
      </section>

      <section className="band">
        <div className="wrap band-row">
          <div>
            <span className="eyebrow">
              {towns.length} municipalities, {communities} named communities
            </span>
            <div className="band-figure">
              <em>{listings}</em> {listings === 1 ? 'listing' : 'listings'} on the island
            </div>
          </div>
          <Link className="btn btn-primary" to="/directory">
            See them
          </Link>
        </div>
      </section>

      <section className="wrap pad">
        <h2>Start with what you need</h2>
        <div className="tile-grid">
          {categories.map((category) => (
            <Link key={category.id} className="tile" to={`/directory/${category.slug}`}>
              <span className="tile-name">{category.name}</span>
              <span className="tile-count">{category.children?.length || 0} categories</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="wrap pad">
        <h2>Or by where you are</h2>
        <IslandRail towns={towns} />
        <p className="note">
          Long Beach Township is not one place — it is five separate stretches of the island
          wrapping the other boroughs. Its named communities are listed in their own right, because
          that is what people search for.
        </p>
      </section>
    </>
  );
}
